<div *ngIf="navData" class="data-wrap" fxLayout="column">
    <div fxLayoutAlign="space-between center" fxLayout="row" fxFlex="grow">
        <div class="title" fxLayoutAlign="start center" fxLayoutGap="5px">
            <mat-icon (click)="advancedModeSub.next(!advancedModeSub.value)" class="{{ navData.data.iconClass }}">{{
                navData.data.icon
            }}</mat-icon>
            <div>{{ navData.data.title }}</div>
        </div>
        <app-ai-model-selector
            [multipleCheck]="advancedModeSub | async"
            [aiModelType]="aiModelType"
            (modelChange)="model = $event"
        ></app-ai-model-selector>
    </div>
    <div class="desc">{{ navData.data.contentBody }}</div>
    <app-ai-prompter-manager
        [model]="model"
        [advancedModeSub]="advancedModeSub"
        (onListMaterial)="onClose.emit({ clearCompData: true })"
        (onMaterialEdited)="onEditMaterial($event)"
        (onMaterialTypeChanged)="aiModelType = $event"
    ></app-ai-prompter-manager>
</div>
